import React from "react"
import { VscCircleLargeFilled } from "react-icons/vsc"
import { useDispatch, useSelector } from "react-redux"
import { Trans, useTranslation } from "react-i18next"
import clsx from "clsx"

import { productUnitsSymbol } from "constant"
import { createComboData, thousandSeparator } from "utils"
import { Button, Modal, } from "components"
import { editComboOrder, updateOrderItem } from "@redux"
import classes from "./CartStockValidationResultModal.module.scss"

const CartStockValidationResultModal = props => {
  const {
    problematicItems,
    openCartValidationResultModal,
    setOpenCartValidationResultModal
  } = props

  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const order = useSelector(state => state.order)

  const foodPriceChanged = (problematicItem) => {
    order.items.forEach(orderItem => {
      const needChange =
        orderItem.optionId ===
        problematicItem.optionId

      if (!needChange) return

      const changedOrderItem = {
        salePrice: problematicItem.newSalePrice,
        stockManagement: problematicItem.stockManagement,
        availableQuantity: problematicItem.availableQuantity
      }

      dispatch(
        updateOrderItem(
          changedOrderItem,
          orderItem.orderItemId
        )
      )
    })

    order.combos.forEach((combo, orderComboIndex) => {
      const newItems =
        combo.items.map(comboItem => {
          const needChange =
            comboItem.optionId ===
            problematicItem.optionId

          return needChange
            ?
            {
              ...comboItem,
              salePrice: problematicItem.newSalePrice,
              stockManagement: problematicItem.stockManagement,
              availableQuantity: problematicItem.availableQuantity
            }
            :
            comboItem
        })

      const editedCombo =
        createComboData(combo, newItems)

      dispatch(
        editComboOrder(
          orderComboIndex,
          editedCombo
        )
      )
    })
  }

  const foodTaxChanged = (problematicItem) => {
    order.items.forEach(orderItem => {
      const needChange =
        orderItem.optionId ===
        problematicItem.optionId

      if (!needChange) return

      const changedOrderItem = {
        taxItems: problematicItem.newTaxItems,
        stockManagement: problematicItem.stockManagement,
        availableQuantity: problematicItem.availableQuantity
      }

      dispatch(
        updateOrderItem(
          changedOrderItem,
          orderItem.orderItemId
        )
      )
    })

    order.combos.forEach((combo, orderComboIndex) => {
      const newItems =
        combo.items.map(comboItem => {
          const needChange =
            comboItem.optionId ===
            problematicItem.optionId

          return needChange
            ?
            {
              ...comboItem,
              taxItems: problematicItem.newTaxItems,
              stockManagement: problematicItem.stockManagement,
              availableQuantity: problematicItem.availableQuantity
            }
            :
            comboItem
        })

      const editedCombo =
        createComboData(combo, newItems)

      dispatch(
        editComboOrder(
          orderComboIndex,
          editedCombo
        )
      )
    })
  }

  const comboPriceChanged = (problematicItem) => {
    order.combos.forEach((combo, orderComboIndex) => {
      const needChange =
        orderComboIndex ===
        problematicItem.orderComboIndex

      if (!needChange) return

      const newCombo = {
        ...combo,
        comboSetSalePrice: problematicItem.newComboSetSalePrice
      }

      const editedCombo =
        createComboData(newCombo, combo.items)

      dispatch(
        editComboOrder(
          orderComboIndex,
          editedCombo
        )
      )
    })
  }

  const changedPriceSpecificationItem = (problematicItem) => {
    order.items.forEach(orderItem => {
      const needChange =
        orderItem.optionId ===
        problematicItem.optionId

      if (!needChange) return

      const newSpecificationItems =
        orderItem.specificationItems.map(si =>
          si._id === problematicItem.specificationItemId
            ?
            {
              ...si,
              salePrice: problematicItem.newSalePrice
            }
            :
            si
        )

      const changedOrderItem = {
        specificationItems: newSpecificationItems
      }

      dispatch(
        updateOrderItem(
          changedOrderItem,
          orderItem.orderItemId
        )
      )
    })
  }

  const updateCart = () => {
    problematicItems.forEach(problematicItem => {
      switch (problematicItem.type) {
        case "foodPriceChanged":
          foodPriceChanged(problematicItem)
          break
        case "foodTaxChanged":
          foodTaxChanged(problematicItem)
          break
        case "comboPriceChanged":
          comboPriceChanged(problematicItem)
          break
        case "changedPriceSpecificationItem":
          changedPriceSpecificationItem(problematicItem)
          break
        default:
      }
    })
  }

  const handleOk = () => {
    updateCart()

    setOpenCartValidationResultModal(false)
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Modal
      show={openCartValidationResultModal}
      onHide={() => setOpenCartValidationResultModal(false)}
    >
      <div className={classes["container"]}>
        <div className={classes["list"]}>
          {problematicItems.map((problematicItem, index) =>
            <div
              key={index}
              className={classes["card"]}
            >
              <VscCircleLargeFilled
                name="checkbox-blank-circle"
                size={5}
                className={clsx(classes["dot"], isLtr && classes["dot-ltr"])}
              />
              {
                problematicItem.type === "limitedFood" &&
                <div
                  className={clsx(
                    classes["details"],
                    isLtr && classes["details-ltr"]
                  )}
                >
                  <div className={classes["name"]}>
                    <Trans i18nKey="limitedFood">
                      {{ foodName1: problematicItem.foodName }}{" "}
                      {{ optionName1: !problematicItem.isSimple ? `(${problematicItem.optionName})` : "" }}
                      <b className={classes["red"]}>
                        محدود
                      </b>
                      {" "}شده است لطفا سفارشتان را تا {" "}
                      <b>
                        حداکثر{" "}
                        {{ availableQuantity: problematicItem.availableQuantity }}{" "}
                        {{ productUnitsSymbol: t(productUnitsSymbol[problematicItem.unit]) }}{" "}
                        {{ foodName2: problematicItem.foodName }}{" "}
                        {{ optionName2: !problematicItem.isSimple ? `(${problematicItem.optionName})` : "" }}
                      </b>
                      {" "}محدود کنید.
                    </Trans>
                  </div>
                </div>
              }
              {
                problematicItem.type === "foodPriceChanged" &&
                <div
                  className={clsx(
                    classes["details"],
                    isLtr && classes["details-ltr"]
                  )}
                >
                  <div className={classes["name"]}>
                    <Trans i18nKey="foodPriceChanged">
                      {{ foodName: problematicItem.foodName }}{" "}
                      {{ optionName: !problematicItem.isSimple ? `(${problematicItem.optionName})` : "" }}
                      {" "}تغییر
                      <b className={classes["red"]}>
                        قیمت
                      </b>{" "}
                      داشته است از{" "}
                      <b>
                        {{ previousSalePrice: thousandSeparator(problematicItem.previousSalePrice) }}
                      </b>
                      {" "}به{" "}
                      <b>
                        {{ newSalePrice: thousandSeparator(problematicItem.newSalePrice) }}
                      </b>
                      .
                    </Trans>
                  </div>
                </div>
              }
              {
                problematicItem.type === "deletedFood" &&
                <div
                  className={clsx(
                    classes["details"],
                    isLtr && classes["details-ltr"]
                  )}
                >
                  <div className={classes["name"]}>
                    <Trans i18nKey="deletedFood">
                      {{ foodName: problematicItem.foodName }}{" "}
                      {{ optionName: !problematicItem.isSimple ? `(${problematicItem.optionName})` : "" }}
                      {" "}
                      <b className={classes["red"]}>
                        ناموجود شده است.
                      </b>
                      {" "}
                      لطفا کالا را از سبد خرید خود حذف کنید.
                    </Trans>
                  </div>
                </div>
              }
              {
                problematicItem.type === "comboDeleted" &&
                <div
                  className={clsx(
                    classes["details"],
                    isLtr && classes["details-ltr"]
                  )}
                >
                  <div className={classes["name"]}>
                    <Trans i18nKey="comboDeleted">
                      {{ comboName: problematicItem.comboName }}{" "}
                      <b className={classes["red"]}>
                        ناموجود شده است.
                      </b>{" "}
                      لطفا کالا را از سبد خرید خود حذف کنید.
                    </Trans>
                  </div>
                </div>
              }
              {
                problematicItem.type === "comboPriceChanged" &&
                <div
                  className={clsx(
                    classes["details"],
                    isLtr && classes["details-ltr"]
                  )}
                >
                  <div className={classes["name"]}>
                    <Trans i18nKey="comboPriceChanged">
                      <b className={classes["red"]}>
                        قیمت
                      </b>
                      {" "}{{ comboName: problematicItem.comboName }}{" "}
                      تغییر کرده است از{" "}
                      <b>
                        {{ previousComboSetSalePrice: thousandSeparator(problematicItem.previousComboSetSalePrice) }}
                      </b>
                      {" "}به{" "}
                      <b>
                        {{ newComboSetSalePrice: thousandSeparator(problematicItem.newComboSetSalePrice) }}
                      </b>
                      .
                    </Trans>
                  </div>
                </div>
              }
              {
                problematicItem.type === "comboNotEligable" &&
                <div
                  className={clsx(
                    classes["details"],
                    isLtr && classes["details-ltr"]
                  )}
                >
                  <div className={classes["name"]}>
                    <Trans i18nKey="comboNotEligable">
                      {{ comboName: problematicItem.comboName }}{" "}
                      <b className={classes["red"]}>
                        معتبر نیست.
                      </b>
                      {" "}لطفا کامبو را دوباره به سبد خرید اضافه کنید.
                    </Trans>
                  </div>
                </div>
              }
              {
                problematicItem.type === "foodTaxChanged" &&
                <div
                  className={clsx(
                    classes["details"],
                    isLtr && classes["details-ltr"]
                  )}
                >
                  <Trans i18nKey="foodTaxChanged">
                    <b className={classes["red"]}>
                      مالیات
                    </b>
                    {" "}
                    {{ foodName: problematicItem.foodName }}{" "}
                    {{ optionName: !problematicItem.isSimple ? `(${problematicItem.optionName})` : "" }}
                    {" "}تغییر کرده است.
                  </Trans>
                </div>
              }
              {
                problematicItem.type === "outOfStockSpecificationItem" &&
                <div
                  className={clsx(
                    classes["details"],
                    isLtr && classes["details-ltr"]
                  )}
                >
                  <div className={classes["name"]}>
                    <Trans i18nKey="outOfStockSpecificationItem">
                      {{ specificationItemName: problematicItem.specificationItemName }}{" "}
                      {{ foodName: problematicItem.foodName }}{" "}
                      دیگر{" "}
                      <b className={classes["red"]}>
                        موجود نیست.
                      </b>
                      {" "}لطفا این افزودنی را از سبد خرید تان حذف کنید.
                    </Trans>
                  </div>
                </div>
              }
              {
                problematicItem.type === "changedPriceSpecificationItem" &&
                <div
                  className={clsx(
                    classes["details"],
                    isLtr && classes["details-ltr"]
                  )}
                >
                  <div className={classes["name"]}>
                    <Trans i18nKey="changedPriceSpecificationItem">
                      قیمت{" "}
                      {{ specificationItemName: problematicItem.specificationItemName }}{" "}
                      افزودنی {" "}
                      {{ foodName: problematicItem.foodName }}{" "}
                      <b className={classes["red"]}>
                        تغییر کرده است
                      </b>
                      {" "}از{" "}
                      <b>
                        {{ previousSalePrice: thousandSeparator(problematicItem.previousSalePrice) }}
                      </b>
                      {" "}به{" "}
                      <b>
                        {{ newSalePrice: thousandSeparator(problematicItem.newSalePrice) }}
                      </b>
                      .
                    </Trans>
                  </div>
                </div>
              }
            </div>
          )}
        </div>

        <div className={classes["footer"]}>
          <Button
            color="success"
            onClick={handleOk}
          >
            {t("تایید")}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default CartStockValidationResultModal